import { ExamPeriodMonitor } from "@types"
import { Progress } from "antd"
import { useSignalRConnection } from "@hooks"
import { useEffect, useState } from "react"

interface Props {
    examMonitor: ExamPeriodMonitor
}

export const TableProgressBar = ({examMonitor}: Props) => {

    const {events} = useSignalRConnection();
    const [percentage, setPercentage] = useState<number>(0);

    useEffect(() => {

        const handleMessage = (type: string, message: string, examInstanceId?: string) => {
            if (type === "percentage" && examMonitor.id === examInstanceId  ) {
                setPercentage(parseInt(message));
            }
        };

        const cleanUp = events(handleMessage);

        return () => {
            if (cleanUp) {
                cleanUp();
            }
        };
    }, [events]);
    return (
        <Progress percent={percentage == 0 ? examMonitor.percentageOfCompletion : percentage}/>
    )
}